import script from "./CreateShopNewsDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateShopNewsDialog.vue?vue&type=script&setup=true&lang=js"

import "./CreateShopNewsDialog.vue?vue&type=style&index=0&id=02fd5169&lang=css"
import "./CreateShopNewsDialog.vue?vue&type=style&index=1&id=02fd5169&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02fd5169"]])

export default __exports__